export const initLeadership = () => {
  console.log('initLeadership');
  const columnCount = document.querySelectorAll('.leadership-grid__grid--item:not(.full)');
  const grid = document.querySelector('.leadership-grid__grid');
  let value = 5;

  switch (columnCount.length) {
    case 2:
      value = 2;
      break;
    case 3:
      value = 3;
      break;
    case 4:
      value = 4;
      break;
  }

  grid.style.setProperty('--grid-column-count', value);
  console.log('columnCount', value, grid.style.getPropertyValue('--grid-column-count'));
}



// WEBPACK FOOTER //
// ./src/templates/components/newdev-leadership/leadership.js